import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WindowShopManagerHeaderComponent } from './window-shop-manager-header.component';
import { MatDividerModule } from '@angular/material/divider';


@NgModule({
  imports: [
    CommonModule,
    MatDividerModule
  ],
  exports: [
    WindowShopManagerHeaderComponent
  ],
  providers: [
  ],
  declarations: [
    WindowShopManagerHeaderComponent
  ]
})
export class WindowShopManagerHeaderModule { }